export default __webpack_public_path__ + "static/media/about-team-mo-ismail.8717eb94.png";